import React, {useContext, useEffect, useState} from 'react';

import {withRouter} from 'react-router-dom'
import {Collapse} from 'reactstrap';
import MenuFooter from "../modules/widgets/MenuFooter";


import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {faAngleDown} from '@fortawesome/pro-light-svg-icons/faAngleDown';
import {faAngleUp} from '@fortawesome/pro-light-svg-icons/faAngleUp';

import DropdownMenu from './menu/DropdownMenu';
import LinkBlock from './menu/LinkBlock';
import MobileNavBar from './menu/MobileNavBar';
import LangContext from "../providers/LangContext";
import {buildTree, flattenTree} from "../helpers";

const checkChildActive = (page, currentPath) => {
    let data = '';
    if ((typeof page.children === 'undefined' || page.children.length == 0)) {
        if (page.slug === currentPath) {
            return true;
        }
    } else {
        let results = page.children.map((page) => checkChildActive(page, currentPath));
        if (results.indexOf(true) >= 0 || results.indexOf('active') >= 0) {
            data = 'active';
        }
    }
    return data;
}

const menuMaker = (page, sitePrefix, item_key, currentPath, isMobile) => {
    return <ConstructMenuItem key={page.id}  page={page} sitePrefix={sitePrefix} item_key={item_key}
                              currentPath={currentPath}
                              isMobile={isMobile}/>
}

const Menu = ({toggleMenu, sitePrefix, menuCollapsed, logo, mobileLogo, currentPath, pages, isMobile, customSiteWidget, purchasePrice, status, icons}) => {

    const {lang} = useContext(LangContext);
    const [state, setState] = useState({
        pagesTree: []
    });

    useEffect(() => {
        setState({
            ...state,
            pagesTree: buildTree(pages)
        })
    }, [pages])

    useEffect(() => {
        if (window.innerWidth < 991) {
            //on mobile collapse the menu
            window.scrollTo(0, 0)
            toggleMenu('close')
        }
    }, [currentPath])

    let item_key = 1;

    return (
        <div>
            <MobileNavBar mobileLogo={mobileLogo} sitePrefix={sitePrefix} toggleMenu={toggleMenu}
                          menuCollapsed={menuCollapsed}/>

            <Collapse isOpen={menuCollapsed} className="menu">
                <nav>
                    {state.pagesTree.map(function (page, index) {
                        item_key++;
                        {
                            return menuMaker(page, sitePrefix, item_key, currentPath, isMobile)
                        }
                    })}
                </nav>
                <MenuFooter customSiteWidget={customSiteWidget}
                            purchasePrice={purchasePrice} status={status}
                            icons={icons} />
            </Collapse>
            <div onClick={toggleMenu} className="menu-collapse v2-collapse d-none d-lg-block"
                 data-toggle="collapse"
                 data-target=".menu"
                 aria-controls="menu" aria-expanded="true" aria-label="Toggle navigation" title="Verberg menu">
                <div className="v1-collapse">
                    {menuCollapsed ?
                        <img src="/images/menu_hide_arrow_top.png" width="48" height="48" title="Verberg menu"/> :
                        <img src="/images/menu_hide_arrow_bottom.png" width="48" height="48" title="Verberg menu"/>}
                </div>
                <div className="v2-collapse">
                    {menuCollapsed ? <FontAwesomeIcon size="3x" icon={faAngleUp}/> :
                        <FontAwesomeIcon size="3x" icon={faAngleDown}/>}
                </div>
            </div>
        </div>
    )
}

export default withRouter(Menu);

const ConstructMenuItem = ({page, sitePrefix, item_key, isMobile, currentPath}) => {
    if ((typeof page.children === 'undefined' || page.children.length == 0)) {
        return (
            <LinkBlock {...page} key={page.id} sitePrefix={sitePrefix}/>
        )
    } else {
        item_key++;
        let activeClass = checkChildActive(page, currentPath);
        return (
            <DropdownMenu item_key={item_key} currentPath={currentPath} isMobile={isMobile} key={page.id} page={page} sitePrefix={sitePrefix}
                          activeClass={activeClass} menuMaker={menuMaker}/>
        )
    }
}
